let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8hsGx")).then(() => parcelRequire('7Lp0f'));